import { IProductState } from "@faire/deprecated-retailer-visitor-shared/views/product/getProductState";
import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";

import { IBrandReviewSummary } from "../hooks/interfaces";

export const SHOW_SIDE_CART_QUERY_PARAM = "showSideCart";
export const SHOW_SIDE_CART_QUERY_PARAM_VALUE = "1";

export const SHOW_IMAGE_GALLERY_QUERY_PARAM = "showImageGallery";
export const SHOW_IMAGE_GALLERY_QUERY_PARAM_VALUE = "1";

export const SHOW_IMAGE_GALLERY_INDEX_QUERY_PARAM = "showImageGalleryIndex";

export interface IProductPageCartData {
  numberOfItemsInCart: number;
  cartTotal: IFaireMoney | undefined;
}

export interface IPDPViewportData {
  isDesktopAndAbove: boolean;
  isTablet: boolean;
  isTabletAndAbove: boolean;
  isTabletAndBelow: boolean;
  isMobile: boolean;
}

export interface IProductPageData {
  productState: IProductState;
  brandReviewSummary: IBrandReviewSummary;
  viewportData: IPDPViewportData;
  showSideCart: boolean;
  showImageGallery: boolean;
  pdpSettings: IPDPSettings;
  preselectedProductOptionToken: string | undefined;
  quantityMap: Map<string, number> | undefined;
}

export interface IProductPageProps {
  productToken: string;
  productPageData: IProductPageData;
}

export interface IPDPSettings {
  cartBuildingAndSavingsGuide: boolean;
  isSduiMigrationEnabled: boolean;
}
